import { HttpClient, HttpContext, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, retry, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar'; // Import MatSnackBar
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseUrl: string = environment.apiUrl;
  private httpOptions: {
    body?: any;
    headers: {
      [header: string]: string | string[];
    };
    context?: HttpContext;
    observe?: 'body';
    params?: HttpParams | {
      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
    };
    reportProgress?: boolean;
    responseType: 'json';
    withCredentials?: boolean;
  } = {
    headers: { 'Content-Type': 'application/json' },
    responseType: 'json'
  };

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar, // Inject MatSnackBar here
  ) {}

  public get<T>(url: string, retryCount: number = 0, notShowError?:boolean): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}/${url}`, this.getJsonOptions()).pipe(
      retry(retryCount),
      catchError(error => this.handleError(error, notShowError ? notShowError : false))
    );
  }

    public getFile<T>(url: string, retryCount: number = 0, notShowError?:boolean): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.baseUrl}/${url}`, { observe: 'response', responseType: 'blob' }).pipe(
      retry(retryCount),
      catchError(error => this.handleError(error, notShowError ? notShowError : false))
    );
  }

  public post<T>(url: string, data: any, retryCount: number = 0,notShowError?:boolean): Observable<T> {
    return this.http.post<T>(`${this.baseUrl}/${url}`, data,this.getJsonOptions()).pipe(
      retry(retryCount),
      catchError(error => this.handleError(error, notShowError ? notShowError : false))
    );
  }

  public put<T>(url: string, data: any, retryCount: number = 0,notShowError?:boolean): Observable<T> {
    return this.http.put<T>(`${this.baseUrl}/${url}`, data, this.getJsonOptions()).pipe(
      retry(retryCount),
      catchError(error => this.handleError(error, notShowError ? notShowError : false))
    );
  }

   public patch<T>(url: string, data: any, retryCount: number = 0,notShowError?:boolean): Observable<T> {  
      return this.http.patch<T>(`${this.baseUrl}/${url}`, data,this.getJsonOptions()).pipe(
        retry(retryCount),
        catchError(error => this.handleError(error, notShowError ? notShowError : false))
      );
    }

  public delete<T>(url: string, retryCount: number = 0,notShowError?:boolean, body?: any | null): Observable<T> {
    return this.http.delete<T>(`${this.baseUrl}/${url}`, {headers: this.getJsonOptions().headers, body}).pipe(
      retry(retryCount),
      catchError(error => this.handleError(error, notShowError ? notShowError : false))
    );
  }

  public postFormData<T>(url: string, data: any, retryCount: number = 0,notShowError?:boolean): Observable<T> {
    return this.http.post<T>(`${this.baseUrl}/${url}`, data, this.getFormDataOptions()).pipe(
      retry(retryCount),
      catchError(error => this.handleError(error, notShowError ? notShowError : false))
    );
  }

  public setHeader(key: string, value: string | undefined) {
    if (value) {
      if (this.httpOptions.headers) {
        this.httpOptions.headers[key] = value;
      } else {
        this.httpOptions.headers = {
          key: value
        };
      }
    } else {
      delete this.httpOptions.headers[key];
    }
  }

  private handleError(error: any, notShowError:boolean) {
    if(notShowError){
      return throwError(() => {
        return null;
      });
    }
    console.log(error)
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else if (error.error.listaErrori) {
      // Get server-side error
      error.error.listaErrori.forEach((errorItem: { codiceErrore: string, descrizioneErrore: string }) => {
        this.snackBar.open(`Errore: ${errorItem.descrizioneErrore}`, 'close', {
          duration: 3000, // Optional: Set duration for snack bar
        });
      });
    } else if (error.error.codiceErrore) {
      this.snackBar.open(`Errore: ${error.error.descrizioneErrore}`, 'close', {
        duration: 3000,
      });
    } else if (error.error.error) {
      this.snackBar.open(`Errore: Mi dispiace, qualcosa non va. <br>(${error.error.status} - ${error.error.error})`, 'close', {
        duration: 3000,
      });
    } else {
      console.log(error);
      this.snackBar.open(`Errore: Mi dispiace, il server non risponde.`, 'close', {
        duration: 3000,
      });
    }


    return throwError(() => {
      return errorMessage;
    });

  }

 private getJsonOptions(extraHeaders?: { [header: string]: string }): {
    headers: { [header: string]: string | string[] };
    responseType: 'json';
    observe: 'body';
  } {
    return {
      headers: {
        ...this.httpOptions.headers,
        ...extraHeaders
      },
      responseType: 'json',
      observe: 'body'
    };
  }


  private getFormDataOptions(extraHeaders?: { [header: string]: string }): {
    headers: { [header: string]: string | string[] };
    responseType: 'json';
    observe: 'body';
  } {
    const filteredHeaders = { ...this.httpOptions.headers };
    delete filteredHeaders['Content-Type'];

    return {
      headers: {
        ...filteredHeaders,
        ...extraHeaders
      },
      responseType: 'json',
      observe: 'body'
    };
  }

}
